import React from 'react';
function BookmarkTabs({ 
  setSessionsDrawerOpen, 
  setPatternsDrawerOpen,
  sessionsDrawerOpen,
  patternsDrawerOpen
}) {
  
  const handleTabClick = (tab) => {
    if (tab === 'sessions') {
      setSessionsDrawerOpen(prev => !prev);
    } else if (tab === 'patterns') {
      setPatternsDrawerOpen(prev => !prev);
    }
  };

  return (
    <div className="bookmark-system">
      <div className="bookmark-tabs">
        <div 
          className={`bookmark-tab ${sessionsDrawerOpen ? 'active' : ''}`}
          onClick={() => handleTabClick('sessions')}
        >
          Sessions
        </div>
        <div 
          className={`bookmark-tab ${patternsDrawerOpen ? 'active' : ''}`}
          onClick={() => handleTabClick('patterns')}
        >
          Redaction Patterns
        </div>
      </div>
    </div>
  );
}

export default BookmarkTabs; 
